import { render, staticRenderFns } from "./assessment-modal.vue?vue&type=template&id=02ce60ec&scoped=true"
import script from "./assessment-modal.vue?vue&type=script&lang=js"
export * from "./assessment-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ce60ec",
  null
  
)

export default component.exports